'use strict'

import React, { PropTypes }   from 'react'
import YourSummary            from './your-summary'
import CustomerServiceDetails from '../form-segments/customer-service-details'
import {notify}               from 'react-notify-toast'
import $                      from 'jquery'
import Footer2                from '../assets/footer2'

export default class FlowForm extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      currentPage: 0
    }

    this.changePage = this.changePage.bind(this)
  }

  lastPage () {

    if (this.state.currentPage) {
      this.setState({
        currentPage: --this.state.currentPage
      })
    } else if (this.state.currentPage === 0){
      this.props.returnToIntro();
    }

    this.state.currentPage === 3 ? window.hideMenu(true) : window.hideMenu(false)
  }

  changePage (skip, e) {
    e && e.preventDefault()

    if (this.checkDisabled()) {
      notify.show('Please fill in the required fields.', 'error', 4000)
      $('input.required').css('border-color', '#EF5350')
      return false
    }

    const { pages, onPageChange, onFinish } = this.props

    let nextPage = this.state.currentPage

    if (nextPage === 0) {
      window.ga('send', 'event', {
        eventCategory: 'Detailed Form',
        eventAction: 'Step 1',
        eventLabel: 'Start - Bottom'
      })
      window.ga('send', {
        hitType: 'pageview',
        page: 'Voucher form (page 2)'
      })
    } else if (!skip && nextPage === 1) {
      window.ga('send', 'event', {
        eventCategory: 'Detailed Form',
        eventAction: 'Click',
        eventLabel: 'Step 2 - Continue'
      })
      window.ga('send', {
        hitType: 'pageview',
        page: 'Voucher form (page 3)'
      })

      e.target.disabled = true
      e.target.innerHTML = 'processing...'

      this.props.doProspect(this.changePage, e.target, e)
      return
    } else if (nextPage === 2) {
      window.ga('send', 'event', {
        eventCategory: 'Detailed Form',
        eventAction: 'Click',
        eventLabel: 'Step 3 - Continue'
      })
      window.ga('send', {
        hitType: 'pageview',
        page: 'Voucher form (page 4)'
      })
    }

    onPageChange()

    if (nextPage < pages.length - 1) {
      nextPage++
    } else {
      e.target.disabled = true
      e.target.innerHTML = 'processing...'
      onFinish(e.target)
    }

    nextPage === 3 ? window.hideMenu(true) : window.hideMenu(false)

    this.setState({
      currentPage: nextPage
    }, () => {
      nextPage < pages.length - 1 && window.scrollTo(0, 0)
    })
  }

  checkDisabled () {
    const {summary, pages} = this.props

    let disabled = false

    pages[this.state.currentPage].required.forEach((requirement) => {
      if (summary[requirement] === undefined || summary[requirement].invalid) {
        disabled = true
        return
      }
    })

    return disabled
  }

  componentDidMount () {
    const { optimizelyToken } = this.context
    window.optimizely.push(['activate', optimizelyToken])

    window.location.hash.startsWith('#page-') &&
    this.setState({
      currentPage: this.props.currentPage
    })

    window.fbq('track', 'ViewContent')

    window.ga('send', {
      hitType: 'pageview',
      page: 'Voucher form (page 1)'
    })
  }

  render () {
    const {pages, summary} = this.props
    const {currentPage} = this.state

    let buttonText = ['START', 'Continue', 'Continue', 'Confirm Order', 'Finish'][currentPage]

    return (
      <div>
        <YourSummary summary={summary} lastPage={this.lastPage.bind(this)} />
        <form name='voucher-form' id='voucher-form' className='flow-form'>
          <div className='flow-form--page'>
            {pages[currentPage].page}
            <div className='button-container'>
              {currentPage !== 4 &&
                <div className='step-counter'>
                  Step {Math.min(currentPage + 2, 4)} of {Math.min(pages.length + 1, 4)}
                </div>
              }
              <button
                id='next-page'
                className='next-page-button'
                onClick={this.changePage.bind(this, false)}>
                {buttonText}
              </button>
            </div>
          </div>
          <br style={{clear: 'both'}} />
          {currentPage === 4 && <CustomerServiceDetails />}

          {/* Hidden by request until we have example info */}
          {/* currentPage === 2 && <PackageExamples /> */}
          <Footer2 />
        </form>
      </div>
    )
  }
}

FlowForm.contextTypes = {
  optimizelyToken: PropTypes.string,
}




// WEBPACK FOOTER //
// ./src/components/assets/flow-form.js